// extracted by extract-css-chunks-webpack-plugin
module.exports = {"login-container":"login-container_28H_W","login-content":"login-content_fRxix","text":"text_1414m","form-wrap":"form-wrap_1zZFV","form-content":"form-content_Fxs_x"};